<div class="page gray-font-color font-family bodyBackground">
  <div class="header-navigation-back">
    <mat-icon (click)="goBack()" data-test="back-arrow-icon" data-testid="back-arrow-icon">arrow_back</mat-icon>
    <span class="title">Traffic Convictions</span>
  </div>
  @if (!isContentReady) {
    <div>
      <app-skeleton-accident-traffic-records [isAccidentRecord]="false"></app-skeleton-accident-traffic-records>
    </div>
  }
  @if (isContentReady) {
    <div>
      <div class="conviction-question-card">
        <p class="question-label">Have you had any traffic convictions in the last 3 years?</p>
        <div class="radio-with-spinner">
          <mat-radio-group class="conviction-radio-group"
            [value]="getConvictionRadioValue()"
            [disabled]="disableNoTrafficConvictions || radioSaving"
            (change)="onConvictionRadioChange($event)">
            <mat-radio-button value="yes" data-testid="hasConviction-yes">Yes</mat-radio-button>
            <mat-radio-button value="no" data-testid="noConviction-no">No</mat-radio-button>
          </mat-radio-group>
          @if (radioSaving) {
            <mat-spinner diameter="20" class="radio-spinner"></mat-spinner>
          }
        </div>
      </div>

      @if (getConvictionRadioValue() === 'yes' && !openForm) {
      <div class="conviction-hint-text">
        <p class="hint-label">Please add details of each conviction below.</p>
      </div>
      <div class="add-new-container">
        <button mat-button [disabled]="disableAddNewRecord" (click)="onAddNewTrafficConvictionRecord()"
          data-test="add-traffic-record-button" data-testid="add-traffic-record-button">
          <i class="material-icons">add</i> Add New Conviction Record
        </button>
      </div>
      }
      @if (errorMessage) {
        <mat-error class="error padding-left-md">
          {{ errorMessage }}
        </mat-error>
      }
      @if (openForm) {
        <div class="content">
          <div class="component-container">
            <form [formGroup]="trafficConvictionForm" (ngSubmit)="onSubmitTrafficConvictionRecord(false)">
              
              <!-- Basic Information Section -->
              <div class="form-section">
                <h3 class="section-title">Conviction Details</h3>
                <br>
                
                <div class="form-row">
                  <mat-form-field class="form-field" appearance="outline" subscriptSizing="dynamic">
                    <mat-label>Date</mat-label>
                    <input matInput readonly placeholder="Select date" [matDatepicker]="convictionDate"
                      formControlName="convictionDate" [max]="maxDate" (click)="convictionDate.open()" data-testid="date"/>
                    <mat-datepicker-toggle matSuffix [for]="convictionDate" data-test="from-date-form-field">
                      <mat-icon matDatepickerToggleIcon>calendar_today</mat-icon>
                    </mat-datepicker-toggle>
                    <mat-datepicker #convictionDate touchUi="true"> </mat-datepicker>
                    @if (trafficConvictionForm.get('convictionDate')?.touched && trafficConvictionForm.get('convictionDate')?.invalid) {
                      <mat-error>
                        {{ getConvictionDateErrorMessage() }}
                      </mat-error>
                    }
                  </mat-form-field>
                  
                  <mat-form-field class="form-field" appearance="outline" subscriptSizing="dynamic">
                    <mat-label>Violation Type</mat-label>
                    <mat-select formControlName="violationType" data-test="nature-of-violation-selector" data-testid="nature-of-violation-selector">
                      @for (violation of violationTypes; track violation) {
                        <mat-option [value]="violation.value"
                          data-test="violation-type" [attr.data-testid]="'violation-' + violation?.name?.toLowerCase()">{{ violation.name }}
                        </mat-option>
                      }
                    </mat-select>
                    @if (trafficConvictionForm.get('violationType')?.touched && trafficConvictionForm.get('violationType')?.invalid) {
                      <mat-error>
                        {{ getViolationTypeErrorMessage() }}
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
                
                @if (trafficConvictionForm.get('violationType').value === 'other') {
                  <div class="form-row">
                    <mat-form-field class="form-field" appearance="outline" subscriptSizing="dynamic">
                      <mat-label>Other Violation Details</mat-label>
                      <input matInput placeholder="Specify other violation type" formControlName="otherViolationType"
                        data-test="other-violation-form-field" data-testid="other-violation-form-field" required />
                      @if (trafficConvictionForm.get('otherViolationType')?.touched && trafficConvictionForm.get('otherViolationType')?.invalid) {
                        <mat-error>
                          {{ getOtherViolationTypeErrorMessage() }}
                        </mat-error>
                      }
                    </mat-form-field>
                  </div>
                }
                
                <div class="form-row">
                  <mat-form-field class="form-field" appearance="outline" subscriptSizing="dynamic">
                    <mat-label>State of Violation Location</mat-label>
                    <mat-select formControlName="stateOfViolation" data-test="state-of-violation-selector" data-testid="state-of-violation-selector">
                      @for (state of stateOfViolation; track state) {
                        <mat-option [value]="state.value" data-test="state-name" [attr.data-testid]="'state-' + state?.name?.toLowerCase()">{{
                        state.name }} </mat-option>
                      }
                    </mat-select>
                    @if (trafficConvictionForm.get('stateOfViolation')?.touched && trafficConvictionForm.get('stateOfViolation')?.invalid) {
                      <mat-error>
                        {{ getStateOfViolationErrorMessage() }}
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
              </div>

              <!-- Penalty Information Section -->
              <div class="form-section">
                <h3 class="section-title">Penalty Details</h3>
                <br>
                <div class="form-row">
                  <mat-form-field class="form-field" appearance="outline" subscriptSizing="dynamic">
                    <mat-label>Penalty</mat-label>
                    <mat-select formControlName="penalty" data-test="number-of-penalty-selector" data-testid="number-of-penalty-selector">
                      @for (penalty of penalty; track penalty) {
                        <mat-option [value]="penalty.value" data-test="penalty-value" [attr.data-testid]="'penalty-' + penalty?.name?.toLowerCase()">{{
                        penalty.name }}</mat-option>
                      }
                    </mat-select>
                    @if (trafficConvictionForm.get('penalty')?.touched && trafficConvictionForm.get('penalty')?.invalid) {
                      <mat-error>
                        {{ getPenaltyErrorMessage() }}
                      </mat-error>
                    }
                  </mat-form-field>
                  
                  <mat-form-field class="form-field" appearance="outline" subscriptSizing="dynamic">
                    <mat-label>Demerit Points</mat-label>
                    <mat-select formControlName="demeritPoints" data-test="demerit-points-selector" data-testid="demerit-points-selector">
                      @for (demerit of demeritPoints; track demerit) {
                        <mat-option [value]="demerit" data-test="demerit-points-value" [attr.data-testid]="'demerit-' + demerit">{{
                        demerit }}</mat-option>
                      }
                    </mat-select>
                    @if (trafficConvictionForm.get('demeritPoints')?.touched && trafficConvictionForm.get('demeritPoints')?.invalid) {
                      <mat-error>
                        {{ getDemeritPointsErrorMessage() }}
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
              </div>

              <!-- Additional Information Section -->
              <div class="form-section">
                <h3 class="section-title">Additional Information</h3>
                <br>
                
                <mat-form-field class="form-field" appearance="outline" subscriptSizing="dynamic">
                  <mat-label>Notes (Optional)</mat-label>
                  <textarea matInput formControlName="notes" maxlength="140" 
                    placeholder="Enter any additional notes about the conviction"
                    rows="3" data-test="notes-field" data-testid="notes-field"></textarea>
                  <mat-hint align="end">{{ trafficConvictionForm.get('notes').value?.length || 0 }}/140</mat-hint>
                  @if (trafficConvictionForm.get('notes').hasError('pattern')) {
                    <mat-error>
                      Invalid characters used.
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              
            </form>
          </div>
        </div>
      }
      @if (trafficRecords) {
        <div class="content">
          @for (record of trafficRecords; track record) {
            <div class="view-record" [attr.data-testid]="'trafficRec- ' + getViolationValue(record.violationType) + ' - ' + record.convictionDate">
              <div class="info">
                <p class="view-date">{{ record.convictionDate | date: 'dd MMM yyyy' }}</p>
                <p class="view-nature">
                  {{ getViolationValue(record.violationType) || 'No traffic conviction in the last 3 years' }}
                </p>
              </div>
              <div class="actions">
                <mat-icon svgIcon="edit-black" (click)="onEdit(record)"
                data-test="edit-traffic-conviction-record"></mat-icon>
                <mat-icon svgIcon="delete-sweep-outlined" (click)="onDelete(record)"
                data-test="delete-traffic-conviction-record"></mat-icon>
              </div>
            </div>
          }
        </div>
      }
    @if (openForm) {
    <div class="fixed-action-footer">
      <button mat-button class="footer-cancel-btn" (click)="onCancel()" data-testid="cancelBtn">
        Cancel
      </button>
      <button mat-flat-button class="footer-save-btn"
        [disabled]="(!trafficConvictionForm.dirty || !trafficConvictionForm.valid)"
        (click)="onSubmitTrafficConvictionRecord(false)" data-test="save-new-record" data-testid="saveBtn">
        Save
      </button>
    </div>
    }
    </div>
  }
</div>